var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 4.09a10 10 0 00-8.14 15.82l1-.78a8.75 8.75 0 1114.32 0l1 .78A10 10 0 0012 4.09zm3.91 5.42l-5.27 6a1.57 1.57 0 002.72 1.56l2.55-7.55z"
})));

export default SvgIconDashboard;